import React from 'react';
import dayjs from 'dayjs';
import Button from 'components/shared/generic/button/presentational/Button';
import { formatMoney } from 'lib/utils';
import { DirectDebit } from 'lib/type';

interface DirectDebitItemProps {
    data: DirectDebit;
    showCancelModal: () => void;
}

const DirectDebitItem = ({ data, showCancelModal }: DirectDebitItemProps) => {
    return (
        <div className="direct-debit-container">
            <div className="view-direct-debit-container">
                <div className="view-item">
                    <h2>
                        Status:{' '}
                        {data.status[0] + data.status.slice(1).toLowerCase()}
                    </h2>
                </div>

                <div className="view-item">
                    <h2>{data.payeeName}</h2>
                    {data.dueAt && (
                        <h3>{dayjs(data.dueAt).format('DD MMM YYYY')}</h3>
                    )}
                </div>
                <div className="view-item">
                    <h2>Reference</h2>
                    <h3>{data.reference}</h3>
                </div>
                <div className="view-item">
                    <h2>Created</h2>
                    <h3>{dayjs(data.created).format('DD MMM YYYY')}</h3>
                </div>
                {!!data.amount && (
                    <div className="view-item">
                        <h2>Amount</h2>
                        <h3>{'£' + formatMoney(data.amount)}</h3>
                    </div>
                )}
            </div>

            {data.status === 'ACTIVE' && (
                <Button className="danger" onClick={showCancelModal}>
                    Cancel Direct Debit
                </Button>
            )}
        </div>
    );
};

export default DirectDebitItem;
